import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

// Connects to data-controller="slim-select"
export default class extends Controller {
  static values = {
    model: String,
  };

  connect() {
    this.select = new SlimSelect({
      select: this.element,
      settings: {
        closeOnSelect: false,
        hideSelected: true,
        placeholderText: "Select " + this.modelValue,
        maxValuesShown: 1000,
      },
    });
  }

  disconnect() {
    this.select.destroy();
  }
}
